import css from './overview.scss';

export const TABLE_CONFIG = {
    cols: [
        { id: 'class', name: 'MATHLETICS CLASS', sort: { sortAs: 'string' }, trans: 'Label - MathleticsClass' },
        { id: 'teacher', name: 'TEACHER', trans: 'Label - Teacher' },
        { id: 'course', name: 'COURSE', sort: { sortAs: 'string' }, trans: 'Label - Course' },
        { id: 'total', name: 'TOTAL', trans: 'Label - Total' }
    ],
    colGroups: [[
        {
            name: '',
            colIds: ['class', 'teacher', 'course'],
            classes: css['first-group']
        },
        {
            name: 'CERTIFICATES',
            colIds: ['total'],
            classes: 'text-center',
            trans: 'Label - Certificates'
        }
    ]],
    defaultSort: 'class',
    onSelectRow: () => null // this will get populated in Overview component
};


export const NO_CLASSES_FOUND_LOAD = 'Empty - NoClasses';
export const NO_CLASSES_FOUND_SEARCH = 'Empty - NoClassesFound';



// WEBPACK FOOTER //
// ./containers/overview/overview-constants.js